import { isDouyinAppChannel } from './code';

const canUseLocalStorage = typeof localStorage !== undefined;

export const TIKTOK_COUPON_ORDER_NO_STORAGE_KEY = 'TIKTOK_COUPON_ORDER_NO_STORAGE_KEY';

export const setCouponOrderNoForTiktok = (no: string) => {
  if (isDouyinAppChannel() && canUseLocalStorage) {
    localStorage.setItem(TIKTOK_COUPON_ORDER_NO_STORAGE_KEY, no);
  }
};

let timer: ReturnType<typeof setTimeout> | null = null;
export const getCouponOrderNoForTiktok = () => {
  if (isDouyinAppChannel() && canUseLocalStorage) {
    if (timer) {
      clearTimeout(timer);
    }
    const _no = localStorage.getItem(TIKTOK_COUPON_ORDER_NO_STORAGE_KEY);

    if (_no) {
      timer = setTimeout(() => {
        localStorage.removeItem(TIKTOK_COUPON_ORDER_NO_STORAGE_KEY);
      }, 200);
    }
    return _no;
  }
  return undefined;
};
